const localStorageKey = (userId) => `hlt-banners-dismissed-${userId}`;

function getLocalStorageValue(userId) {
  const key = localStorageKey(userId);
  const value = localStorage.getItem(key);
  return JSON.parse(value || '[]');
}

function setLocalStorageValue(userId, data) {
  const key = localStorageKey(userId);
  localStorage.setItem(key, JSON.stringify(data));
}

export function getDismissedBanners() {
  const userId = this.$store.getters['user/get']?.id;
  if (userId) {
    return getLocalStorageValue(userId);
  }
}

export function recordBannerDismissed(bannerId) {
  const userId = this.$store.getters['user/get']?.id;
  if (userId) {
    const storedValue = getLocalStorageValue(userId);
    storedValue.push(bannerId);
    const data = Array.from(new Set(storedValue));
    setLocalStorageValue(userId, data);
  }
}
